// Importing required types for attendance service operations
import {
  AttendanceServicePayload,
  IAssignAttendancePolicyPayload,
  IAttendanceDetailsServiceResponse,
  IAttendanceEmployeeManagerServiceResponse,
  IAttendancePolicyListPayload,
  IAttendancePolicyPayload,
  IAttendancePolicyResponse,
} from "../../../features/attendance/types";
import {
  IBaseResponse,
  IStatusRepsonse,
} from "../../../Types/UserProfileDetails";
import ApiService from "../../ApiService";

enum AttendanceServiceEndpoints {
  ATTENDANCE_DETAILS = "/employee/attendance",
  MARK_ATTENDANCE = "/employee/mark-attendance",
  ATTENDANCE_CORRECTION = "/employee/attendance/correction",
  ATTENDANCE_EMPLOYEE_MANAGER = "/employee/manager",
  ATTENDANCE_POLICY = "/attendance-policy",
  ATTENDANCE_POLICY_ASSIGN = "/attendance-policy/assign",
}

// Defining the AttendanceService class which extends the base ApiService class
class AttendanceService extends ApiService {
  // Function to get the attendance details based on the provided date range and optional user ID
  async getAttendanceDetails(
    activeYear: string | number,
    startDate: Date | string,
    endDate: Date | string,
    userId?: string | number
  ): Promise<IAttendanceDetailsServiceResponse> {
    // Returning the result of the API request to get the attendance details
    // If a user ID is provided, it uses that ID; otherwise, it uses the ID of the logged-in user
    return this.get<IAttendanceDetailsServiceResponse>(
      `${AttendanceServiceEndpoints.ATTENDANCE_DETAILS}/${userId}?active_year=${activeYear}&start_date=${startDate}&end_date=${endDate}`
    );
  }

  // Function to mark attendance for the user
  async markAttendanceUser(attendanceData: FormData) {
    return this.post<IBaseResponse>(
      AttendanceServiceEndpoints.MARK_ATTENDANCE,
      attendanceData
    );
  }

  // Function to handle attendance corrections
  async attedanceCorrection(
    attendanceCorrectionFormData: AttendanceServicePayload
  ) {
    return this.post<IBaseResponse>(
      AttendanceServiceEndpoints.ATTENDANCE_CORRECTION,
      attendanceCorrectionFormData
    );
  }

  // Function to get employee manager details
  async attendanceEmployeeManager(
    id: string | number
  ): Promise<IAttendanceEmployeeManagerServiceResponse> {
    return this.get<IAttendanceEmployeeManagerServiceResponse>(
      `${AttendanceServiceEndpoints.ATTENDANCE_EMPLOYEE_MANAGER}/${id}`
    );
  }

  async getPolicyList(payload: IAttendancePolicyListPayload) {
    return this.get<IAttendancePolicyResponse>(
      `${AttendanceServiceEndpoints.ATTENDANCE_POLICY}${
        payload.dropdown ? `?dropdown=${payload.dropdown}` : ""
      }`
    );
  }

  async addOrUpdatePolicy(payload: IAttendancePolicyPayload) {
    return this.post<IStatusRepsonse>(
      AttendanceServiceEndpoints.ATTENDANCE_POLICY,
      payload
    );
  }

  async assignAttendancePolicy(payload: IAssignAttendancePolicyPayload) {
    return this.post<IStatusRepsonse>(
      AttendanceServiceEndpoints.ATTENDANCE_POLICY_ASSIGN,
      payload
    );
  }
}

// Creating an instance of AttendanceService and exporting it for use in other parts of the application
export const attendanceService = new AttendanceService();
